import { associatedItemsRenderer, dateSorter, periodRenderer } from '@lib/generic.utils'
import { agPriceCol, agStartDateCol, exchangeRateCol } from '@/ag-grid/ag-columns'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
// Components
import ActionsColumn from './ActionsColumn'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        suppressRowClickSelection: true,
        columnDefs: [
          {
            headerName: 'Invoice',
            field: 'name',
            cellRenderer: params => `Invoice ${params.value}`,
            tooltipValueGetter: params => `Invoice ${params.value}`
          },

          {
            headerName: 'Subscriptions',
            field: 'subscription_periods',
            cellRenderer: 'agGroupCellRenderer',
            type: 'rightAligned',
            headerClass: 'text-start',
            valueFormatter: params => params.value.length,
            tooltipValueGetter: params =>
              associatedItemsRenderer(params.value ? params.value.length : 0, 'subscription', 'subscriptions')
          },

          agStartDateCol({
            headerName: 'Payment date',
            field: 'payment_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          {
            headerName: 'Reference',
            field: 'reference',
            tooltipField: 'reference',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRenderer: notAnyValueCheck,
            tooltipValueGetter: notAnyValueCheck
          },

          {
            headerName: 'Payment #',
            field: 'payment_number',
            tooltipField: 'payment_number',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRenderer: notAnyValueCheck,
            tooltipValueGetter: notAnyValueCheck
          },

          agPriceCol('Original price', 'amount'),

          exchangeRateCol(),

          agPriceCol('Final price', 'paid_amount', {
            editable: true,
            cellClass: ['editable-cell', 'ag-right-aligned-cell'],
            cellRenderer: params => notAnyPriceCheck(params, 'normalized_currency'),
            tooltipValueGetter: params => notAnyPriceCheck(params, 'normalized_currency')
          }),

          {
            headerName: 'Actions',
            cellRendererFramework: ActionsColumn,
            minWidth: 100
          }
        ],
        masterDetail: true,
        detailRowAutoHeight: true,
        detailCellRendererParams: {
          detailGridOptions: {
            columnDefs: [
              {
                headerName: 'Name',
                field: 'name',
                flex: 2,
                tooltipField: 'name'
              },

              {
                headerName: 'Period',
                field: 'start_date',
                cellStyle: { textAlign: 'center' },
                headerClass: ['text-center'],
                flex: 2,
                comparator: dateSorter,
                cellRenderer: params => periodRenderer(params.data),
                tooltipValueGetter: params => periodRenderer(params.data)
              },

              agPriceCol('Price', 'amount', { flex: 1 })
            ],
            defaultColDef: {
              suppressMenu: true
            },
            suppressContextMenu: true
          },
          getDetailRowData: params => {
            params.successCallback(params.data.subscription_periods)
          }
        },
        domLayout: 'autoHeight'
      }
    }
  }
}
